import { MailIcon, UserIcon } from "@heroicons/react/outline"
import { Tag } from "components/tag";
import { IOrderAttendantItem, IOrderDetail, OrderStatusKey } from "interfaces";
import React from "react";
import { Link } from "react-router-dom";


interface AttendantCardProps {
  data?: IOrderAttendantItem[];
  orderDetailData: IOrderDetail | null;
  _sendAttendantEmail: (id: string) => void;
}

export const AttendantCard = ({data = [], _sendAttendantEmail, orderDetailData} : AttendantCardProps) => {
  const isSuccessOrder = orderDetailData?.order_status === OrderStatusKey.SUCCESSFUL;
  const getParticipantDetailPage = (participantId: string) => {
    if (!participantId) return;
    return orderDetailData?.event_type === "sports" 
      ? `/participants/sport/${participantId}`
      : orderDetailData?.event_type === "attractions"
        ? `/participants/attraction/${participantId}`
        : "#";
  }
  
  const handleClickCard = (e: any, participantId: string) => {
    const validOrderStatus = orderDetailData?.order_status === OrderStatusKey.SUCCESSFUL || orderDetailData?.order_status === OrderStatusKey.REFUNDED
    if (!participantId || !validOrderStatus) {
      e.preventDefault();
      return;
    }
  };

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 2xl:grid-cols-4">
      {data.map((item: IOrderAttendantItem) => (
        <Link 
          key={item.id}
          to={getParticipantDetailPage(item.participant_id) ?? "#"}
          onClick={(e) => handleClickCard(e, item.participant_id)}
        >
          <div className="h-full border border-gray-200 bg-white rounded-md px-4 py-4 sm:px-6">
            <div className="h-full flex flex-wrap items-start justify-between sm:flex-nowrap">
              <div className="flex items-start">
                <div className="shrink-0 mt-1">
                  <div className="relative bg-magnolia-500 h-10 w-10 rounded-full">
                    <UserIcon className="size-5 text-magnolia-700 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" />
                  </div>
                </div>
                <div className="flex flex-col ml-4 h-full">
                  <p className="text-base font-semibold">
                    {item.first_name} {item.last_name}
                  </p>
                  <div className="text-sm text-gray-500 mb-2" style={{wordBreak: "break-word"}}>
                    <p>
                      {item.email}
                    </p>
                    <p>
                      {item.phone 
                        ? `${item.phone_area_code ? `(+${item.phone_area_code})` : "(+84)"} ${item.phone}` 
                        : ""}
                    </p>
                  </div>
                  <div className="mt-auto">
                    <Tag text={item.is_sent_email_success ? "Email has been sent" : "Email has not been sent"} type={item.is_sent_email_success ? "green" : "pink"}  />
                  </div>
                </div>
              </div>
              {isSuccessOrder ? (
                <div className="ml-4 flex shrink-0">
                  <button
                    type="button"
                    className="relative inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold hover:bg-gray-50"
                    onClick={(e) => {
                      e.preventDefault();
                      _sendAttendantEmail(item.participant_id);
                    }}
                  >
                    <MailIcon aria-hidden="true" className="size-5 text-brand-500" />
                  </button>
                </div>
              ) : <></>}
            </div>
          </div>
        </Link>
      ))}
    </div>
  )
}